import axios from 'axios';
import { normalizeJSONAPIResponse } from 'utils/modelUtils';
import { Endpoint, URL_PARTS } from '../base/endpoints';
import buildRequestUrl from './buildRequestUrl.util';

type Props = {
  endpoint: Endpoint;
  id: string;
  urlParams?: Record<string, string | number | boolean | string[]>;
  payload?: any;
};

export default async function executeApiRequest({ endpoint, id, urlParams, payload }: Props) {
  try {
    const { method } = URL_PARTS[endpoint];
    const url = buildRequestUrl({ endpoint, id, urlParams });

    const response = await axios({ method, url, data: payload });
    return normalizeJSONAPIResponse(response.data);
  } catch (error) {
    console.error(`Error in executeApiRequest for endpoint ${endpoint}:`, error);
    throw error;
  }
}
